import { lazy } from "react";
import store from "@redux/store";
import { BRAND_LIST } from "@type/index";

const DynamicComponent = lazy(() => {
  const { brand_name } = store.getState().config;
  switch (brand_name) {
    case BRAND_LIST.UQ:
      return import("../UQLayout");
    default:
      return import("../UQLayout");
  }
});

export default DynamicComponent;
